import { Toast, ToastType } from 'types/toasts'

export const USDC_BALANCE = 10000
export const POKT_BALANCE = 8000

export const USDC_PERIOD_REWARDS = 200
export const POKT_PERIOD_REWARDS = 160

export const USDC_TOTAL_REWARDS = 5000
export const POKT_TOTAL_REWARDS = 4000

export const CLAIM_RATE_TITLE_INFO = `Claim/Hold Rate for following distributions.`

export const POKT_HOLDINGS_INFO =
  'Your owned POKT in the Pocket Network. Compound your POKT for new Shares.'

export const UNHOLDING_INFO =
  'Sweep any amount of your POKT rewards. Claim their USDC value within the next reward distribution.'

export const CLAIMABLE_INFO = 'USDC rewards ready to be transferred to your wallet.'

export const SELL_INFO = 'Sell any amount of your POKT Shares. Receive their value in WPOKT after Pocket Network\'s cooldown period (21 days).'

export const CURRENT_SELL_INFO = 'WPOKT that will be received from your sell share order.'

export const HOLDINGS_RELEASED_INFO =
  'Pending POKT Sweep (before it appears as Claimable Rewards).'

export const SUCCESS_CLAIM_RATE_TOAST: Toast = {
  title: 'Success!',
  message: 'Your Claim Rate was successfully updated!',
  type: ToastType.Success,
}

export const ERROR_CLAIM_RATE_TOAST: Toast = {
  title: 'Something went wrong',
  message: 'Your Claim Rate could not be updated.',
  type: ToastType.Error,
}

export const SUCCESS_CLAIM_TOAST: Toast = {
  title: 'Success!',
  message: 'Your Rewards were successfully claimed!',
  type: ToastType.Success,
}

export const ERROR_CLAIM_TOAST: Toast = {
  title: 'Something went wrong',
  message: 'Your Rewards could not be claimed.',
  type: ToastType.Error,
}

export const SUCCESS_COMPOUND_TOAST: Toast = {
  title: 'Success!',
  message: 'Your Holdings were successfully compounded!',
  type: ToastType.Success,
}

export const ERROR_COMPOUND_TOAST: Toast = {
  title: 'Something went wrong',
  message: 'Your Holdings could not be compounded.',
  type: ToastType.Error,
}

export const SUCCESS_UNHOLD_TOAST: Toast = {
  title: 'Success!',
  message:
    'Your POKT Sweep Order was successfully created! Claim order value in $USDC within next distribution.',
  type: ToastType.Success,
}

export const ERROR_UNHOLD_TOAST: Toast = {
  title: 'Something went wrong',
  message: 'Your POKT could not be swept.',
  type: ToastType.Error,
}

export const SUCCESS_SELLORDER_TOAST: Toast = {
    title: 'Success!',
    message: 'Your Sell Order was successfully created! Redeem your WPOKT after cooldown period.',
    type: ToastType.Success,
}

export const ERROR_SELLORDER_TOAST: Toast = {
    title: 'Something went wrong',
    message: 'Your Sell Order could not be placed.',
    type: ToastType.Error,
}

export const SUCCESS_WPOKT_CLAIMED_TOAST: Toast = {
    title: 'Success!',
    message: 'Your WPOKT was successfully bridged to Ethereum and a new Sell Order can be placed on Fantom.',
    type: ToastType.Success,
}

export const ERROR_WPOKT_CLAIMED_TOAST: Toast = {
    title: 'Something went wrong',
    message: 'Your WPOKT could not be bridged.',
    type: ToastType.Error,
}

export const ERROR_USER_WPOKT_CLAIMED_TOAST: Toast = {
    title: 'Something went wrong',
    message: 'Your WPOKT was successfully bridged to Ethereum but a new Sell Order can NOT be placed on Fantom.',
    type: ToastType.Error,
}

export const getWPOKT_CLAIMED_TOAST : Toast = {
    title: 'Success!',
    message: 'Your WPOKT was successfully briged. Finish the process accepting the chain change to Fantom and update the contract in order to sell again.',
    type: ToastType.Success,
    chain: '0x1',
}

export const FINISH_WPOKT_CLAIM_TOAST: Toast = {
    title: 'Warning!',
    message: 'No active sells found. Finish the sell process accepting the chain change to Fantom and update the contract in order to sell again.',
    type: ToastType.Warning,
}

export const DISABLED_INFO_IS_NOT_FANTOM =
    'Change to Fantom network'
export const DISABLED_INFO_IS_NOT_ETH = 
    'Change to Ethereum network'
export const DISABLED_INFO_NOT_EXISTS = 'You are not a holder.'

export const DISABLED_INFO_HOLDER_ACTIONS = 'Holder Actions disabled.'

export const DISABLED_INFO_INVESTING_EPOCH =
  'Your money is still in investing epoch.'

export const DISABLED_INFO_ALREADY_CLAIMED =
  'You will be able to claim next epoch.'
